import { ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutFreightGroupItemCompareChangeItem } from "./autogen/AutogenLayoutFreightGroupItemCompareChangeItem";
import { DataSourceMode, TableRowDisplayEvent, TableRow, Checkbox, Label, DataDisplayEvent } from "@mcleod/components";

export class FreightGroupItemCompareChangeItem extends AutogenLayoutFreightGroupItemCompareChangeItem {
    private _compareItems: ModelRow[];

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
    }

    override onLoad(): void | Promise<void> {
        this.tableFreightGroupItemChangeItems.dataSource = this.sourceEdiCompareItem;
        this.tableFreightGroupItemChangeItems.dataSource.data = [];
        if (this._compareItems != null) {
            if (this._compareItems.length === 0) {
                this.tableFreightGroupItemChangeItems.visible = false;
            } else {
                this.tableFreightGroupItemChangeItems.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);
            }
        }
    }

    onItemRowDisplay(event: TableRowDisplayEvent) {
        this.printCheckbox(event.getTableRow());
    }

    printCheckbox(row: TableRow) {
        const checkbox = row.findComponentById("checkboxApply") as Checkbox;
        checkbox.printable = false;
        const labelChecked = row.findComponentById("labelChecked") as Label;
        checkbox.addClickListener(() => labelChecked.visible = checkbox.checked);
    }

    valueOnDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        if (label.caption == "1900-01-01") {
            label.caption = "";
        }
    }

    onDescrDisplay(event: DataDisplayEvent) {
        const labelDescr = <Label>event.target
        if (StringUtil.isEmptyString(event.rowData.get("target_descr"))) {
            labelDescr.caption = event.rowData.get("source_descr");
        }
    }
}
